
<app-header #heada *ngIf="!isBelow768"></app-header>
<app-mobile-menu></app-mobile-menu>
<div class=" h-screen">
<div #scale class="scale">
<div class="container padding-top-section" id="containerLayout">
    <router-outlet></router-outlet>
</div>
</div>
</div>